module.exports = __webpack_public_path__ + "static/media/isa2.f979d3f5.png";